<template>
  <el-dialog
    title="案件备注"
    :visible="visible"
    width="760px"
    append-to-body
    @close="close"
  >
    <el-form :inline="true" @submit.native.prevent
      ><el-form-item
        ><el-input
          v-model.trim="content"
          placeholder="输入备注内容"
          maxlength="512"
          show-word-limit
          style="width: 500px"
          @keyup.enter.native="save"/></el-form-item
      ><el-form-item
        ><el-button type="primary" :loading="saving" @click="save"
          >添加备注</el-button
        ></el-form-item
      ></el-form
    >
    <el-table v-loading="loading" :data="rows" border stripe max-height="420"
      ><el-table-column
        prop="created_at"
        label="日期"
        width="180"
        :formatter="dateFormatter"/><el-table-column
        prop="operator"
        label="发起人"
        width="140"/><el-table-column
        prop="content"
        label="备注内容"
        min-width="300"
    /></el-table>
  </el-dialog>
</template>

<script>
import { getClaimNotes, saveClaimNote } from "@/api/claims-management";
import { formatDateTime } from "../constants";
export default {
  name: "ClaimNotesDialog",
  props: { visible: Boolean, orderId: [String, Number] },
  data() {
    return { loading: false, saving: false, content: "", rows: [] };
  },
  watch: {
    visible(value) {
      if (value) this.load();
    }
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const res = await getClaimNotes({
          order_id: Number(this.orderId),
          page: 1,
          rows: 1000
        });
        this.rows = res.rows || [];
      } finally {
        this.loading = false;
      }
    },
    async save() {
      if (!this.content) return this.$message.warning("请输入备注内容");
      this.saving = true;
      try {
        await saveClaimNote({
          order_id: Number(this.orderId),
          content: this.content
        });
        this.$message.success("添加成功");
        this.content = "";
        this.load();
      } finally {
        this.saving = false;
      }
    },
    dateFormatter(row, column, value) {
      return formatDateTime(value);
    },
    close() {
      this.$emit("update:visible", false);
    }
  }
};
</script>
